(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 900px)');
  var headerNav = document.querySelector('.plz-header-section .plz-nav');
  if (!headerNav) return;

  var headerSection = document.querySelector('.plz-header-section');
  var announcement = document.querySelector('.plz-announcement-bar-section');
  var drawer = headerNav.querySelector('.plz-header__drawer');
  var layer = document.getElementById('plz-header-drawer-layer');
  if (!drawer || !layer || !headerSection) return;

  if (layer.parentElement !== document.body) {
    document.body.appendChild(layer);
  }

  var summary = drawer.querySelector('summary');
  var scrollLockY = 0;
  var pinnedEls = [];

  function visibleBottom(el) {
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;
    return rect.bottom;
  }

  function isAnnouncementVisible() {
    if (!announcement) return false;
    var rect = announcement.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom > 0;
  }

  function measureChromeBottom() {
    var bottom = 0;

    if (pinnedEls.length) {
      pinnedEls.forEach(function (el) {
        bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
      });
      return bottom;
    }

    bottom = Math.max(visibleBottom(announcement), visibleBottom(headerSection));
    if (bottom <= 0) {
      bottom = headerNav.getBoundingClientRect().bottom;
    }

    return bottom;
  }

  function syncHeaderOffset() {
    var bottom = measureChromeBottom();

    if (!layer.hidden && headerNav) {
      bottom = headerNav.getBoundingClientRect().bottom;
      if (announcement && isAnnouncementVisible()) {
        bottom = Math.max(bottom, announcement.getBoundingClientRect().bottom);
      }
    }

    if (bottom > 0) {
      document.documentElement.style.setProperty('--plz-header-offset', bottom.toFixed(2) + 'px');
    }
  }

  function pinHeaderForDrawer() {
    unpinHeader();

    var showAnnouncement = isAnnouncementVisible();
    var headerTop = 0;

    if (showAnnouncement && announcement) {
      var annRect = announcement.getBoundingClientRect();
      announcement.classList.add('plz-header--modal-pinned');
      announcement.style.setProperty('--plz-header-pinned-top', Math.round(annRect.top) + 'px');
      pinnedEls.push(announcement);
      headerTop = Math.round(annRect.bottom);
    } else if (headerSection) {
      headerTop = Math.round(headerSection.getBoundingClientRect().top);
      if (headerTop < 0) headerTop = 0;
    }

    if (headerSection) {
      headerSection.classList.add('plz-header--modal-pinned');
      headerSection.style.setProperty('--plz-header-pinned-top', headerTop + 'px');
      pinnedEls.push(headerSection);
    }
  }

  function unpinHeader() {
    pinnedEls.forEach(function (el) {
      el.classList.remove('plz-header--modal-pinned');
      el.style.removeProperty('--plz-header-pinned-top');
    });
    pinnedEls = [];
  }

  function isMobileDrawer() {
    return MOBILE_MQ.matches;
  }

  function lockDrawerScroll() {
    scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('plz-drawer-scroll-locked');
    document.body.classList.add('plz-drawer-open');
  }

  function unlockDrawerScroll() {
    document.documentElement.classList.remove('plz-drawer-scroll-locked');
    document.body.classList.remove('plz-drawer-open');
    window.scrollTo(0, scrollLockY);
  }

  function showLayer() {
    if (!layer.hidden) return;

    document.querySelectorAll('.plz-header-section').forEach(function (el) {
      el.classList.remove('shopify-section-header-hidden');
    });

    pinHeaderForDrawer();
    if (isMobileDrawer()) lockDrawerScroll();

    requestAnimationFrame(function () {
      syncHeaderOffset();
      requestAnimationFrame(function () {
        syncHeaderOffset();
        layer.hidden = false;
        drawer.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function hideLayer() {
    if (layer.hidden) return;

    layer.hidden = true;
    drawer.setAttribute('aria-expanded', 'false');
    unpinHeader();
    unlockDrawerScroll();
    requestAnimationFrame(syncHeaderOffset);
  }

  function closeDrawer() {
    if (drawer.open) drawer.open = false;
    else hideLayer();
  }

  syncHeaderOffset();
  window.addEventListener('resize', syncHeaderOffset);

  var scrollRaf = null;
  window.addEventListener(
    'scroll',
    function () {
      if (layer.hidden) return;
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        syncHeaderOffset();
      });
    },
    { passive: true }
  );

  if (typeof ResizeObserver !== 'undefined') {
    if (announcement) new ResizeObserver(syncHeaderOffset).observe(announcement);
    new ResizeObserver(syncHeaderOffset).observe(headerSection);
    new ResizeObserver(syncHeaderOffset).observe(headerNav);
  }

  if (summary) {
    summary.addEventListener('click', function () {
      document.querySelectorAll('.plz-header-section').forEach(function (el) {
        el.classList.remove('shopify-section-header-hidden');
      });
      syncHeaderOffset();
    });
  }

  drawer.addEventListener('toggle', function () {
    if (drawer.open) {
      showLayer();
    } else {
      hideLayer();
    }
  });

  layer.querySelectorAll('[data-plz-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  layer.querySelectorAll('.plz-header__drawer-link[href]').forEach(function (link) {
    link.addEventListener('click', closeDrawer);
  });

  layer.querySelectorAll('[data-plz-social-open]').forEach(function (trigger) {
    trigger.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !layer.hidden) {
      closeDrawer();
    }
  });

  MOBILE_MQ.addEventListener('change', function () {
    if (!isMobileDrawer() && !layer.hidden) {
      closeDrawer();
    }
    syncHeaderOffset();
  });
})();
